export const formateDate = (date) => {
  if (date === null) return "";
  return `${date["$y"]}-${date["$M"] + 1}-${date["$D"]}`
}